module.exports = __webpack_public_path__ + "static/media/b33@2x.d69ab86e.png";